/** @jsx jsx */
import { jsx } from "@emotion/core"
import React, { Component } from "react"
import PropTypes, { func } from "prop-types"
import {
  otpContainerStyles,
  wrappper,
  inputStyle,
  otpInput,
  hideLoader,
  loaderCss,
} from "./styles"
import { ActivityIndicator } from "../../components/ActivityIndicator"

/**
- Standard OTPInput component for accepting n digit otp.
 it wraps a input with n number of rows to look like 4 separate input box.
**/

export class OtpInput extends Component {
  input = React.createRef()
  constructor(props) {
    super(props)
    this.state = {
      value: "",
      focused: false,
      showLoader: false,
    }
  }
  CODE_LENGTH = new Array(this.props.otpLength).fill(0)
  handleClick = () => {
    this.input.current.focus()
  }
  handleFocus = () => {
    this.setState({ focused: true })
  }
  handleBlur = () => {
    this.setState({
      focused: false,
    })
  }
  handleKeyUp = (e) => {
    const { value } = this.state
    if (e.key === "Backspace") {
      this.setState((state) => {
        return {
          value: state.value.slice(0, state.value.length - 1),
          showLoader: false,
        }
      })
    } else if (value.length === this.CODE_LENGTH.length) {
      this.setState({ showLoader: true })
      this.props.onOtpSubmit(value)
    }
  }
  handleChange = (e) => {
    if (isNaN(Number(e.target.value.trim()))) {
      return
    } else {
      const fieldValue = e.target.value.trim()
      const value = (this.state.value + fieldValue).slice(
        0,
        this.CODE_LENGTH.length
      )
      this.props.onChange && this.props.onChange(value)
      this.setState((state) => {
        if (state.value.length >= this.CODE_LENGTH.length) return null
        return {
          value,
        }
      })
    }
  }
  clearInputValues = () => {
    this.setState({
      value: "",
      showLoader: false,
    })
  }
  render() {
    const { value, focused, showLoader } = this.state
    const { error } = this.props
    const values = value.split("")
    const selectedIndex =
      values.length < this.CODE_LENGTH.length
        ? values.length
        : this.CODE_LENGTH.length - 1
    const hideInput = !(values.length < this.CODE_LENGTH.length)

    return (
      <div css={otpContainerStyles} className="otp-input-container">
        <div
          className="input-div-box"
          css={wrappper}
          onClick={this.handleClick}
        >
          <input
            value=""
            ref={this.input}
            onChange={this.handleChange}
            onKeyUp={this.handleKeyUp}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            css={inputStyle(selectedIndex, hideInput)}
          />
          {this.CODE_LENGTH.map((v, index) => {
            const selected = values.length === index
            const filled =
              values.length === this.CODE_LENGTH.length &&
              index === this.CODE_LENGTH.length - 1

            return (
              <div className="input-div" key={index} css={otpInput}>
                {values[index]}
                {(selected || filled) && focused && (
                  <div className="input-focussed" />
                )}
              </div>
            )
          })}
        </div>
        <div
          className="loader-section"
          css={showLoader ? loaderCss : hideLoader}
        >
          <ActivityIndicator style={{ color: "#fff" }} />
        </div>
      </div>
    )
  }
}
OtpInput.propTypes = {
  /** it will return the otp value */
  onOtpSubmit: PropTypes.func,
  /** number of input field to be displayed */
  otpLength: PropTypes.number,
}

OtpInput.defaultProps = {
  otpLength: 4,
}
